import script from "./RentalDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./RentalDashboard.vue?vue&type=script&setup=true&lang=js"

import "./RentalDashboard.vue?vue&type=style&index=0&id=edd54ad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edd54ad2"]])

export default __exports__